export default __webpack_public_path__ + "static/card-2-2707ee41e81d6f2f03f3e341140bf97a.png";